import MyInputsTable from './MyInputsTable.jsx'

function MyRoleInputs() {
  return (
    <>
      <div className='d-flex'>
        <div className='d-flex flex-wrap flex-stack mb-6'>
          <h3 className='fw-bolder my-2'>My Inputs</h3>
        </div>
      </div>

      <div className='card mb-5 mb-xl-10'>
        <MyInputsTable />
      </div>
    </>
  )
}

export default MyRoleInputs
